import {
    IAuthResult,
    LoginEcUser,
    ILoginEcUser,
    IConfirmAccount,
    ConfirmAccount,
    CheckAccountConfirmationToken,
    ISendConfirmationEmailAgain,
    SendConfirmationEmailAgain,
    IConfirmEmailByToken,
    ConfirmEmailByToken,
    IChangePassword,
    ChangePassword,
    ISendEmailForResetPassword,
    SendEmailForResetPassword,
    CheckResetPasswordToken,
    ICheckResetPasswordToken,
    IResetPassword,
    ResetPassword,
} from '../../api/ApiClient';
import { setAuthToken, timingSynchronizer, setHeaderTitle } from '_helpers';
import { INotification } from 'components';
import { createModel } from '@rematch/core';
import apiConnector from '../../api/ApiConnector';

const initialState: AuthState = null;

export default createModel({
    state: initialState as AuthState,
    reducers: {
        setAuth(state, data: IAuthResult) {
            return { ...(state || {}), ...data };
        },
        logout() {
            localStorage.clear();

            return initialState;
        },
    },
    effects: (dispatch: any) => ({
        async login(data: ILoginEcUser) {
            const auth = await apiConnector.execApi(dispatch, apiClient => apiClient.login(new LoginEcUser(data)));

            if (!auth) return;

            timingSynchronizer.setTimeZone(auth.profile.region.timeZoneOffset);
            setAuthToken(auth.token);
            setHeaderTitle(auth.profile.ecInfo.name);

            this.setAuth(auth);
        },
        async fetchProfile() {
            const profile = await apiConnector.execApi(dispatch, apiClient => apiClient.profile());
            this.setAuth({ profile });
            if (!profile) return;

            timingSynchronizer.setTimeZone(profile.region.timeZoneOffset);
        },
        async checkAccountConfirmationTokenAsync(token: string) {
            const checkResult = await apiConnector.execApi(dispatch, apiClient => apiClient.checkAccountConfirmationToken(new CheckAccountConfirmationToken({ token })));

            return checkResult;
        },
        async confirmAccountAsync(data: IConfirmAccount) {
            const auth = await apiConnector.execApi(dispatch, apiClient => apiClient.confirmAccount(new ConfirmAccount(data)));
            if (!auth) return;

            setAuthToken(auth.token);

            this.setAuth({ profile: auth.profile });
        },
        async sendEmailForResetPasswordAsync(body: ISendEmailForResetPassword) {
            const res = await apiConnector.execApi(dispatch, apiClient => apiClient.sendEmailForResetPassword(new SendEmailForResetPassword(body)));

            return res;
        },
        async checkResetPasswordTokenAsync(body: ICheckResetPasswordToken) {
            await apiConnector.execApi(dispatch, apiClient => apiClient.checkResetPasswordToken(new CheckResetPasswordToken(body)));
        },
        async resetPasswordAsync(body: IResetPassword) {
            const res = await apiConnector.execApi(dispatch, apiClient => apiClient.resetPassword(new ResetPassword(body)));

            if (res) {
                setAuthToken(res.token);
                this.setAuth(res);
                dispatch.notifications.addNotification([{ message: 'Пароль успешно изменен!', appearance: 'success' }] as INotification[]);
            }
            return res;
        },
        async sendConfirmationEmailAsync(body: ISendConfirmationEmailAgain) {
            const res = await apiConnector.execApi(dispatch, apiClient => apiClient.sendConfirmationEmailAgain(new SendConfirmationEmailAgain(body)));
            if (res) {
                dispatch.notifications.addNotification([{ message: 'Ссылка для подтверждения электронной почты успешно отправлена!', appearance: 'success' }] as INotification[]);
            }
            return res;
        },
        async confirmEmailByTokenAsync(body: IConfirmEmailByToken) {
            const res = await apiConnector.execApi(dispatch, apiClient => apiClient.confirmEmailByToken(new ConfirmEmailByToken(body)));
            if (res) {
                dispatch.notifications.addNotification([{ message: 'Email успешно подтвержден!', appearance: 'success' }] as INotification[]);
            }
            return res;
        },
        async changePasswordAsync(body: IChangePassword) {
            const res = await apiConnector.execApi(dispatch, apiClient => apiClient.changePassword(new ChangePassword(body)));

            if (res) {
                dispatch.notifications.addNotification([{ message: 'Пароль успешно изменен!', appearance: 'success' }] as INotification[]);
            }
            return res;
        },
    }),
});

type AuthState = IAuthResult | null;
